import { de } from './de';
import { en } from './en';

// `process.env.NEXT_PUBLIC_LOCALE` is compared inline (not via the `LOCALE`
// constant) so the bundler folds the ternary at build time and drops the
// unused dictionary from the client bundle.
const locale = process.env.NEXT_PUBLIC_LOCALE === 'de' ? de : en;

export { locale };
